export const LEGEND_PLACEMENT = {
    OVERLAY: 'overlay',
    HEADER: 'header',
    HIDDEN: 'hidden',
} as const;

export type LegendPlacement = (typeof LEGEND_PLACEMENT)[keyof typeof LEGEND_PLACEMENT];

export const LEGEND_PLACEMENTS = Object.values(LEGEND_PLACEMENT) as readonly LegendPlacement[];

export const DEFAULT_LEGEND_PLACEMENT = LEGEND_PLACEMENT.OVERLAY;

export function isLegendPlacement(value: unknown): value is LegendPlacement {
    return LEGEND_PLACEMENTS.includes(value as LegendPlacement);
}

export function resolveLegendPlacement(value: unknown): LegendPlacement {
    if (typeof value === 'undefined') {
        return DEFAULT_LEGEND_PLACEMENT;
    }

    if (!isLegendPlacement(value)) {
        const described = typeof value === 'string' ? value : typeof value;
        throw new Error(`Unsupported legend placement: ${described}`);
    }

    return value;
}
